import React, { useState, useEffect } from "react";
import UpcomingInstallmentListing from "./UpcomingInstallmentListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setIsTableLoading,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setItems,
  setTotalItems,
} from "src/redux/slices/UpcomingInstallmentSlice";
import moment from "moment";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import InstallmentPaymentWrapper from "../InstallmentPayment/InstallmentPaymentWrapper";
import { useGetInstallmentsQuery } from "src/services/InstallmentServices";
import { useParams } from "react-router-dom";


type Props = {};

const UpcomingInstallmentListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { studentId = "" } = useParams();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.upcomingInstallment);

  const [isOpenPayInstallmentForm, setIsOpenPayInstallmentForm] =
    useState(false);

  const [selectedInstallmentId, setSelectedInstallmentId] = useState("");

  const { data, isLoading, isFetching } = useGetInstallmentsQuery({
    limit: 10,
    searchValue: "",
    params: ["studentName" , "amount"],
    page: 0,
    filterBy: [
      {
        fieldName: "studentId",
        value: studentId,
      },
      {
        fieldName: "isPayed",
        value: false,
      },
    ],
    dateFilter: {},
    orderBy: "dueDate",
    orderByValue:1,
    isPaginationRequired: false,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const columns: columnTypes[] = [
    {
      field: "dueDate",
      headerName: "Due Date",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => (
        <div> {moment(row?.dueDate).format("DD MMM YYYY")} </div>
      ),
    },
  
    {
      field: "amount",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => <div> &#8377; {row?.amount} </div>,
    },
    {
      field: "paymentIn",
      headerName: "Payment In",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => (
        <div className="py-2">
          <ATMLoadingButton
            onClick={() => {
              setSelectedInstallmentId(row?._id);
              setIsOpenPayInstallmentForm(true);
            }}
            className="bg-teal-700 h-[32px] font-semibold"
          >
            {" "}
            Payment In{" "}
          </ATMLoadingButton>
        </div>
      ),
    },
  ];

  return (
    <div>
      <UpcomingInstallmentListing
        columns={columns
        }
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />

      {isOpenPayInstallmentForm ? (
        <InstallmentPaymentWrapper
          onClose={() => setIsOpenPayInstallmentForm(false)}
          installmentId={selectedInstallmentId}
        />
      ) : null}
    </div>
  );
};

export default UpcomingInstallmentListingWrapper;
